<script setup lang="ts">
import { _formatNumber, cloneDeep } from '@/utils'
import bus, { EVENT_KEY } from '@/utils/bus'
import { Icon } from '@iconify/vue'
import { useClick } from '@/utils/hooks/useClick'
import { inject } from 'vue'
import { request } from '@/utils/request'

const props = defineProps({
  isMy: {
    type: Boolean,
    default: () => {
      return false
    }
  },
  item: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const position = inject<any>('position')

const emit = defineEmits(['update:item', 'goUserInfo', 'showShare', 'goMusic'])

function _updateItem(props, key, val) {
  const old = cloneDeep(props.item)
  old[key] = val
  emit('update:item', old)
  bus.emit(EVENT_KEY.UPDATE_ITEM, { position: position.value, item: old })
}

async function loved() {
  let params = {};
  let data = {id:props.item.aweme_id,type:!props.item.isLoved};
  const rs = await request({ url: '/shop/?_Action=short&_Method=like', method: 'post', params, data })

  setTimeout(() => {
    _updateItem(props, 'isLoved', !props.item.isLoved)
  }, 100)
  if (!props.item.isLoved) {
    // eslint-disable-next-line vue/no-mutating-props
  } else {
    // eslint-disable-next-line vue/no-mutating-props
  }
}

const vClick = useClick()
</script>

<template>
  <div class="toolbar mb1r">
    <div class="wefwe" v-click="() => bus.emit(EVENT_KEY.FULL_VIDEO)" style="z-index: 8;">
    <div class="avatar-ctn mb2r">
      <img
        class="avatar"
        src="../../assets/logo.png"
        alt=""
      />
      <transition name="fade">
        <div class="options">
          FULL
        </div>
      </transition>
    </div>
    </div>

    <div class="love mb2r" v-click="loved">
      <div>
        <img src="../../assets/img/icon/heart.svg" class="love-image" v-if="!item.isLoved" />
        <img src="../../assets/img/icon/loved.svg" class="love-image" v-if="item.isLoved" />
      </div>
    </div>
    <div class="share mb2r" v-click="() => bus.emit(EVENT_KEY.SHOW_SHARE)">
      <img src="../../assets/img/icon/share.svg" alt="" class="share-image" />
    </div>
 
    <!--    <BaseMusic-->
    <!--        :cover="item.music.cover"-->
    <!--        v-click="$router.push('/home/music')"-->
    <!--    /> -->
  </div>

</template>

<style scoped lang="less">
.toolbar {
  //width: 40px;
  position: absolute;
  bottom: 0;
  right: 10rem;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .avatar-ctn {
    position: relative;

    @w: 45rem;

    .avatar {
      width: @w;
      height: @w;
      border: 3rem solid white;
      border-radius: 50%;
    }

    .options {
      position: absolute;
      border-radius: 10%;
      margin: auto;
      padding:3rem 0;
      left: 0;
      right: 0;
      bottom: -8px;
      background: red;
      font-size:10rem;
      //background: black;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 1s;
      width:36rem;

      img {
        position: absolute;
        width: 14rem;
        height: 14rem;
        transition: all 1s;
      }

      .yes {
        opacity: 0;
        transform: rotate(-180deg);
      }

    }
  }

  .love,
  .message,
  .share {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @width: 35rem;

    img {
      width: @width;
      height: @width;
    }

    span {
      font-size: 12rem;
    }
  }

  .icon {
    font-size: 40rem;
  }

  .loved {
    background: red;
  }
}
</style>
